import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaintenanceRoutingModule } from './maintenance-routing.module';
import { MaintenanceAddComponent } from './maintenance-add/maintenance-add.component';
import { MaintenanceSupplierComponent } from './maintenance-supplier/maintenance-supplier.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { IMaskModule } from 'angular-imask';
import { AgGridModule } from 'ag-grid-angular';
import { MaintenanceListComponent } from './maintenance-list/maintenance-list.component';
import { MaintenanceSupplierComparisonComponent } from './maintenance-supplier-comparison/maintenance-supplier-comparison.component';
import { AddItemComponent } from './add-item/add-item.component';
import { MaintenanceUpdateComponent } from './maintenance-update/maintenance-update.component';
import { MaintenanceViewComponent } from './maintenance-view/maintenance-view.component';
import { MaskCardPipe } from '../mask-card.pipe';
 import { SharedModule } from '../shared/shared.module';


@NgModule({
    declarations: [
        MaintenanceAddComponent,
        MaintenanceSupplierComponent,
        MaintenanceListComponent,
        MaintenanceSupplierComparisonComponent,
        AddItemComponent,
        MaintenanceUpdateComponent,
        MaintenanceViewComponent,
        MaskCardPipe
    ],
    imports: [
        CommonModule,
        MaintenanceRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        BrowserAnimationsModule,
        NgxSpinnerModule,
        AgGridModule,
        IMaskModule,
        SharedModule
    ],
    exports: [
        MaskCardPipe
    ]
})
export class MaintenanceModule { }
